import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    debug: false,
    question: 1,
    personalSelection: Array<string>(),
    personalFrameworks: new Set<string>(),
    confidentialSelection: Array<string>(),
    confidentialFrameworks: new Set<string>(),
    regionSelection: Array<string>(),
    regionFrameworks: new Set<string>(),
    statesSelection: Array<string>(),
    statesFrameworks: new Set<string>(),
    industrySelection: "none",
    industryFrameworks: new Set<string>(),
    biometricSelection: "",
    biometricFrameworks: new Set<string>(),
    softwareSelection: "",
    softwareFrameworks: new Set<string>(),
    defenseSelection: "",
    defenseFrameworks: new Set<string>(),
    ownershipSelection: "",
    ownershipFrameworks: new Set<string>(),
    childrenSelection: "",
    childrenFrameworks: new Set<string>(),
    excludedFrameworks: new Set<string>()
  },
  mutations: {
    debug(state): void {
      state.debug = true;
    },
    reset(state): void {
      state.question = 1;
      state.personalSelection = Array<string>();
      state.personalFrameworks = new Set<string>();
      state.confidentialSelection = Array<string>();
      state.confidentialFrameworks = new Set<string>();
      state.regionSelection = Array<string>();
      state.regionFrameworks = new Set<string>();
      state.statesSelection = Array<string>();
      state.statesFrameworks = new Set<string>();
      state.industrySelection = "none";
      state.industryFrameworks = new Set<string>();
      state.biometricSelection = "";
      state.biometricFrameworks = new Set<string>();
      state.softwareSelection ="";
      state.softwareFrameworks = new Set<string>();
      state.defenseSelection = "";
      state.defenseFrameworks = new Set<string>();
      state.ownershipSelection = "";
      state.ownershipFrameworks = new Set<string>();
      state.childrenSelection = "";
      state.childrenFrameworks = new Set<string>();
      state.excludedFrameworks = new Set<string>();
    },
    nextQuestion(state): void {
      state.question++;
    },
    prevQuestion(state): void {
      state.question--;
    },
    personalSelection(state, selection: string[]): void {
      state.personalSelection = selection;
    },
    personalFrameworks(state, frameworks: Set<string>): void {
      state.personalFrameworks = frameworks;
    },
    confidentialSelection(state, selection: string[]): void {
      state.confidentialSelection = selection;
    },
    confidentialFrameworks(state, frameworks: Set<string>): void {
      state.confidentialFrameworks = frameworks;
    },
    regionSelection(state, selection: string[]): void {
      state.regionSelection = selection;
    },
    regionFrameworks(state, frameworks: Set<string>): void {
      state.regionFrameworks = frameworks;
    },
    statesSelection(state, selection: string[]): void {
      state.statesSelection = selection;
    },
    statesFrameworks(state, frameworks: Set<string>): void {
      state.statesFrameworks = frameworks;
    },
    industrySelection(state, selection: string): void {
      state.industrySelection = selection;
    },
    industryFrameworks(state, frameworks: Set<string>): void {
      state.industryFrameworks = frameworks;
    },
    biometricSelection(state, value: string): void {
      state.biometricSelection = value;
    },
    biometricFrameworks(state, frameworks: Set<string>): void {
      state.personalFrameworks = frameworks;
    },
    softwareSelection(state, value: string): void {
      state.softwareSelection = value;
    },
    softwareFrameworks(state, frameworks: Set<string>): void {
      state.softwareFrameworks = frameworks;
    },
    defenseSelection(state, value: string): void {
      state.defenseSelection = value;
    },
    defenseFrameworks(state, frameworks: Set<string>): void {
      state.defenseFrameworks = frameworks;
    },
    ownershipSelection(state, value: string): void {
      state.ownershipSelection = value;
    },
    ownershipFrameworks(state, frameworks: Set<string>): void {
      state.ownershipFrameworks = frameworks;
    },
    childrenSelection(state, value: string): void {
      state.childrenSelection = value;
    },
    childrenFrameworks(state, frameworks: Set<string>): void {
      state.childrenFrameworks = frameworks;
    },
    excludedFrameworks(state, frameworks: Set<string>): void {
      state.excludedFrameworks = frameworks;
    }
  },
  getters: {
    mergedFrameworks(state): Set<string> {
      const merged = [
        ...state.personalFrameworks,
        ...state.confidentialFrameworks,
        ...state.regionFrameworks,
        ...state.statesFrameworks,
        ...state.industryFrameworks,
        ...state.biometricFrameworks,
        ...state.softwareFrameworks,
        ...state.defenseFrameworks,
        ...state.ownershipFrameworks,
        ...state.childrenFrameworks
      ];
      return new Set(merged.filter(fw => !state.excludedFrameworks.has(fw)));
    }
  },
  actions: {},
  modules: {}
});
